import config from "../../config";
import matchSupportedLocale from "../locale/matchSupportedLocale";

export const AUTH_REQUEST_LANG_FIELD = "lang";

export default function appendLangToAuthRequestData(requestData, locale) {
  return {
    ...requestData,
    [AUTH_REQUEST_LANG_FIELD]:
      matchSupportedLocale(locale) || config.defaultLocale
  };
}
